import en from "commonAssets/i18n/en";
import merge from "lodash.merge";

const overrides = {
    claim_edit_instructions:
        "Please update any payment election fields and then click Submit on the bottom of this page to update your Payment Election Form.",
    claim_edit_notice:
        'Submitted a payment election? <a href="javascript:void(0);" id="editClaimBtn">Click here</a> to edit your payment election.',
    claim_edit_title: "Edit Payment Election",
    claim_form_errors: "There are errors on the Payment Election Form.",
    claim_processing_email_error:
        "Your contact email address must match the email address provided in your payment method selection. Please update your primary email or telephone number in the Contact Information section to match your payment information.",
    claim_processing_error:
        "There was an error processing your request, please refresh the page and try again.",
    claim_processing_phone_error:
        "Your contact phone number must match the phone number provided in your payment method selection.",
    claim_submit_error:
        "There was an error submitting your payment election, please try again.",
    claim_submit_success: "Thank you, your payment election has been submitted.",
    confirmation_page: {
        title: "Your Payment Election Form has been submitted successfully.",
        claim_details: {
            title: "Your Payment Election Details",
            body: "PAYMENT ELECTION INFORMATION",
            footer: '<p class="text-center fs-6">If you have any questions regarding your Payment Election, please provide the Submitted Correlation ID listed above when contacting the Settlement Administrator.</p>',
        },
    },
    confirmation_this_is_a_copy: "THIS IS A COPY OF YOUR PAYMENT ELECTION FORM",
    confirmation_screen_additional: {
        body: '<p class="fw-bold">You will receive a confirmation and copy of your payment election via email, including your Submission ID and Confirmation Code. Do not share your Submission ID or Confirmation Code with others. We will never call you for this information.</p><p>You may also print this screen for your records.</p><p>If you don\'t receive a confirmation email after 3 days, please check your spam filter.</p>',
    },
    contact_us_select_dropdown: {
        claim_form: "Payment Election Form",
    },
    deadline_claim: "The deadline to submit a Payment Election has passed.",
    nav_submit_claim_button: "Payment Election",
    not_eligible_submit_claim: "You are not eligible to submit a payment election.",
    otp_instructions_2:
        "Please enter the 6 digit code below to access your payment election form.",
    claim_id_if_known: "Submission ID (if known)",
};

export default {
    en: merge({}, en, overrides),
};
